import { ButtonHTMLAttributes } from 'react';
import { IconButton } from '@style/emotion';
import { useDebouncedCallback } from 'use-debounce';
import { useHelper } from 'src/hooks';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  dataTest?: string;
  path?: string;
}

function ShareBtn(props: Props): JSX.Element {
  /* Define state / hook */
  const { path } = props;
  const { REACT_APP_API_BASE_URL } = process.env;
  const { t } = useTranslation();
  const { copyText } = useHelper();
  const location = useLocation();

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */
  const copyLink = useDebouncedCallback(
    () => {
      copyText(
        `${REACT_APP_API_BASE_URL}/share${path || location.pathname}`,
        t('toastMessage.linkCopied')
      );
    },
    1000,
    { leading: true, trailing: false }
  );

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return (
    <IconButton
      className={props.className}
      data-test={props.dataTest}
      onClick={copyLink}
    >
      <i aria-hidden className="fa fa-share-alt" />
    </IconButton>
  );
}

export default ShareBtn;
